var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtoms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0935C15.6569 14.0935 17 15.4366 17 17.0935C17 18.7504 15.6569 20.0935 14 20.0935C12.3431 20.0935 11 18.7504 11 17.0935C11 15.4366 12.3431 14.0935 14 14.0935ZM4 10.0935C6.20914 10.0935 8 11.8844 8 14.0935C8 16.3026 6.20914 18.0935 4 18.0935C1.79086 18.0935 0 16.3026 0 14.0935C0 11.8844 1.79086 10.0935 4 10.0935ZM14 16.0935C13.4477 16.0935 13 16.5412 13 17.0935C13 17.6458 13.4477 18.0935 14 18.0935C14.5523 18.0935 15 17.6458 15 17.0935C15 16.5412 14.5523 16.0935 14 16.0935ZM4 12.0935C2.89543 12.0935 2 12.9889 2 14.0935C2 15.1981 2.89543 16.0935 4 16.0935C5.10457 16.0935 6 15.1981 6 14.0935C6 12.9889 5.10457 12.0935 4 12.0935ZM12.5 0.0935059C15.5376 0.0935059 18 2.55594 18 5.59351C18 8.63111 15.5376 11.0935 12.5 11.0935C9.4624 11.0935 7 8.63111 7 5.59351C7 2.55594 9.4624 0.0935059 12.5 0.0935059ZM12.5 2.09351C10.567 2.09351 9 3.66051 9 5.59351C9 7.52651 10.567 9.09351 12.5 9.09351C14.433 9.09351 16 7.52651 16 5.59351C16 3.66051 14.433 2.09351 12.5 2.09351Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtoms);
export default __webpack_public_path__ + "static/media/atoms.e5d45c2edef289baff9c8ba44fe36d1b.svg";
export { ForwardRef as ReactComponent };